import { Routes } from "@angular/router";

import { LoggedInGuard } from "./core/guards/logged-in.guard";
import { AuthorizationGuard } from "./core/guards/authorization.guard";
import { features } from "./core/constants/features";
import {LoginComponent} from "~/pages/login/login.component";
import { RedirectComponent } from "./components/redirect/redirect.component";

export const routes: Routes = [
    // Metadados do deploy (público — antes de redirects e wildcard)
    {
        path: "deploy-info",
        loadComponent: () =>
            import("./pages/deploy-info/deploy-info.component").then(
                (m) => m.DeployInfoComponent,
            ),
    },

    // Back Office & Admin
    {
        path: "back-office",
        loadChildren: () =>
            import("./pages/back-office/back-office.routes").then(
                (m) => m.backOfficeRoutes,
            ),
        canActivate: [LoggedInGuard, AuthorizationGuard],
        data: { roles: features.PANEL },
    },
    {
        path: "admin",
        component: LoginComponent,
        data: { roles: features.PANEL },
    },

    // Default Window Route (lazy-loaded)
    {
        path: "",
        redirectTo: "admin",
        pathMatch: "full",
    },

    {
        path: 'coupon',
        loadChildren: () => import('./pages/coupon-page-mobile/coupon-page-mobile.module').then((m) => m.CouponPageMobileModule),
    },

    // Wildcard route
    {
        path: "**",
        pathMatch: "full",
        component: RedirectComponent,
    },
];
